import { getItemWeightWithMeta, WeightMatchType } from "@sellar-io/common";

export type CanonicalWeightCheckInput = {
  containerType: string | null | undefined;
  unit: string | null | undefined;
  volume: number | null | undefined;
  packQuantity: number | null | undefined;
  weight: number | null | undefined;
};

/**
 * Resolves the canonical (table-looked-up) weight for a product shape, and
 * reports whether a given weight deviates significantly (>2x or <0.5x) from
 * it — used to prefill/validate the weight field on product forms against
 * the same canonical table getItemWeight uses at calculation time.
 */
export function useCanonicalWeightCheck({
  containerType,
  unit,
  volume,
  packQuantity,
  weight,
}: CanonicalWeightCheckInput) {
  const result = getItemWeightWithMeta({
    containerType: containerType ?? null,
    unit: unit ?? null,
    volume: volume ?? null,
    packQuantity: packQuantity ?? null,
    weight: null,
  });

  const canonicalWeight =
    result.matchType === WeightMatchType.DIRECT_MATCH ? result.weight : null;

  const weightDeviatesFromCanonical =
    canonicalWeight != null &&
    weight != null &&
    !Number.isNaN(weight) &&
    (weight > canonicalWeight * 2 || weight < canonicalWeight * 0.5);

  return { canonicalWeight, weightDeviatesFromCanonical };
}
